import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'common/components';

const ColumnVisibilityCheckbox = ({ textId, checked, onClick }) => (
  <Checkbox
    textId={textId}
    checked={checked}
    onClick={onClick}
    labelClassName="NewBaseTable__visibility__checkbox-label"
  />
);

ColumnVisibilityCheckbox.propTypes = {
  textId: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const MemoziedColumnVisibilityCheckbox = memo(ColumnVisibilityCheckbox, (prev, next) => prev.checked === next.checked);

export default MemoziedColumnVisibilityCheckbox;
